__turbopack_context__.v({
  "ratings-bar": "ReviewRatings-module-scss-module__Q7ikuq__ratings-bar",
  "ratings-bar-inner": "ReviewRatings-module-scss-module__Q7ikuq__ratings-bar-inner",
  "ratings-layout": "ReviewRatings-module-scss-module__Q7ikuq__ratings-layout",
  "ratings-section": "ReviewRatings-module-scss-module__Q7ikuq__ratings-section",
  "ratings-title": "ReviewRatings-module-scss-module__Q7ikuq__ratings-title",
});
